import type { FieldValues, Path, UseFormSetError } from "react-hook-form";
import { ApiError } from "./ApiError";

// Augment both specifiers so workspace consumers (importing from
// "@sidegigllc/api") and published consumers (importing from
// "@sidegigllc/api/resources") both see the method on ApiError.
declare module "@sidegigllc/api" {
  // oxlint-disable-next-line typescript/no-explicit-any -- unknown rejects the types assigned here
  interface ApiError<T extends Record<string, any>> {
    // oxlint-disable-next-line typescript/method-signature-style -- method syntax keeps bivariant parameters
    setFormErrors<FormValues extends FieldValues = T>(
      setError: UseFormSetError<FormValues>,
      mapping?: Partial<{ [key in keyof T]: Path<FormValues> }>,
    ): void;
  }
}

declare module "@sidegigllc/api/resources" {
  // oxlint-disable-next-line typescript/no-explicit-any -- unknown rejects the types assigned here
  interface ApiError<T extends Record<string, any>> {
    // oxlint-disable-next-line typescript/method-signature-style -- method syntax keeps bivariant parameters
    setFormErrors<FormValues extends FieldValues = T>(
      setError: UseFormSetError<FormValues>,
      mapping?: Partial<{ [key in keyof T]: Path<FormValues> }>,
    ): void;
  }
}

ApiError.prototype.setFormErrors = function setFormErrors<
  // oxlint-disable-next-line typescript/no-explicit-any -- unknown rejects the types assigned here
  T extends Record<string, any>,
  FormValues extends FieldValues = T,
>(
  this: ApiError<T>,
  setError: UseFormSetError<FormValues>,
  mapping: Partial<{ [key in keyof T]: Path<FormValues> }> = {},
) {
  const errorMessages = (this.error.details ?? []).reduce(
    (acc, detail) => {
      if (!detail.target) return acc;
      acc[detail.target as keyof T] = detail.message;
      return acc;
    },
    (this.error.target ? { [this.error.target]: this.error.message } : {}) as { [key in keyof T]: string },
  );

  for (const field of Object.keys(errorMessages)) {
    const key = (mapping[field as keyof T] ?? field) as Path<FormValues>;
    setError(key, { type: "api", message: this.getFieldErrorMessage(field) });
  }
};
